/** Official Arabic legal name — do not auto-translate differently */
export const COMPANY_NAME_AR = 'شركة تقنيات الجودة للمقاولات';

/** Placeholder kept in Latin so Google Translate does not corrupt the Arabic name */
export const COMPANY_NAME_PLACEHOLDER = 'QTECH_CONTRACTING_CO';

/** English phrases → placeholder (longest first) */
export const COMPANY_NAME_EN_REPLACEMENTS = [
  ['Quality Technologies Contracting (Q-Tech)', `${COMPANY_NAME_PLACEHOLDER} (Q-Tech)`],
  ['Quality Technologies Contracting', COMPANY_NAME_PLACEHOLDER],
  ['Q-Tech Contracting', COMPANY_NAME_PLACEHOLDER],
];

/** Wrong Arabic orderings only — never partial matches inside the correct name */
export const COMPANY_NAME_WRONG_AR = [
  'جودة التقنيات للمقاولات',
  'جودة التقنيات',
];
